<template>
  <div>
    <div>
      <span class="mt-2 text-heading"> Pricing </span>
      <v-row class="mt-3">
        <v-col cols="12" md="2">
          <div class="d-flex justify-center mt-2">
            <span class=""><b> Public Price</b></span>
          </div>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            label=""
            type=""
            v-model="$v.formData.price.$model"
            outlined
            single-line
            hide-details=""
            dense
            @input="SetPrice"
          >
            <template v-slot:append>
              <img
                width="21px"
                height="21px"
                src="../../assets/SvgIcons/dollar.svg"
              />
            </template>
          </v-text-field>
          <div v-if="$v.formData.price.$error">
            <span class="red--text"> Profuct Name is required </span>
          </div>
        </v-col>
      </v-row>
      <div class="py-6">
        <span class=""
          ><b> Member Pricing</b><v-icon
          class=""
          color="primary"
          text
          style="text-transform: none"
          @click="addRow"
        >
          mdi-plus
        </v-icon>
          <br />
          <span style="color: red; font-weight: 100; font-size: 13px">{{
            memberError
          }}</span></span
        >
      </div>
      <div>
        <v-row class="" v-for="(div, index) in divs" :key="div.id">
          <v-col cols="12" md="4">
            <v-select
              label=""
              outlined
              single-line
              hide-details=""
              v-model="div.MemberId"
              :items="getMembership"
              item-text="Name"
              item-value="Id"
              dense
              @change="updateMemberPricing"
            ></v-select>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              label=""
              type=""
              outlined
              single-line
              hide-details=""
              dense
              v-model="div.Price"
              @input="updateMemberPricing"
            >
              <template v-slot:append>
                <img
                  width="21px"
                  height="21px"
                  src="../../assets/SvgIcons/dollar.svg"
                />
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" md="2">
            <v-icon
              class=""
              color="primary"
              text
              style="text-transform: none"
              @click="deleteRow(index)"
            >
            mdi-minus
            </v-icon>
            <!-- <v-icon
              v-else
              class=""
              color="primary"
              text
              style="text-transform: none"
              @click="deleteRow(index)"
            >
              mdi-minus
            </v-icon> -->
          </v-col>
        </v-row>
      </div>

      <div class="d-flex">
        <v-switch
          color="#419D26"
          hide-details
          @change="SetDiscount"
          v-model="showform"
        >
        </v-switch>
        <span class="mt-5"><b> Discount</b></span>
      </div>
      <div v-if="showform">
        <v-row class="mt-3">
          <v-col cols="12" md="3">
            <v-text-field
              v-model="$v.formData.DiscountPercentage.$model"
              label="% Percentage"
              @input="SetPercentage"
              hide-details=""
              ></v-text-field>
            <div v-if="$v.formData.DiscountPercentage.$error">
              <span class="red--text"> percentage Name is required </span>
            </div>
          </v-col>
          <v-col cols="12" md="9">
            <v-select
              label="Apply To"
              :items="valuearry"
              multiple
              @input="SetApplyTo"
              v-model="formData.applyto"
              hide-details=""
            ></v-select>
          </v-col>
        </v-row>
        <v-row class="mb-15">
          <v-col cols="12" md="6" class="">
            <v-menu
              ref="menumodal"
              v-model="menumodal"
              :close-on-content-click="false"
              :return-value.sync="formData.StartTime"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="formData.StartTime"
                  label="Start Date"
                  append-icon="mdi-calendar-range-outline"
                  readonly
                  single-line
                  v-bind="attrs"
                  v-on="on"
                  :error-messages="
                      $v.formData.StartTime.$error
                        ? 'TimeStart is required'
                        : null
                    "
                ></v-text-field>
                
              </template>
              <v-date-picker v-model="formData.StartTime" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menumodal = false">
                  Cancel
                </v-btn>
                <v-btn text color="primary" @click="SetStartDate"> OK </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="6" class="">
            <v-menu
              ref="modal"
              v-model="modal"
              :close-on-content-click="false"
              :return-value.sync="formData.EndTime"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="formData.EndTime"
                  label="End Date"
                  append-icon="mdi-calendar-range-outline"
                  readonly
                  single-line
                  v-bind="attrs"
                  v-on="on"
                  :error-messages="
                      $v.formData.EndTime.$error
                        ? 'TimeStart is required'
                        : null
                    "
                ></v-text-field>
              </template>
              <v-date-picker v-model="formData.EndTime" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="modal = false">
                  Cancel
                </v-btn>
                <v-btn text color="primary" @click="SetEndDate"> OK </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <div class="d-flex">
            <v-switch
              color="#419D26"
              v-model="taxable"
              hide-details
              @change="SetTaxable"
            >
            </v-switch>
            <span class="mt-5"><b> Is Taxable</b></span>
          </div>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
export default {
  props: ["pricingcomp"],
  data() {
    return {
      taxable: false,
      showform: false,
      formData: {
        price: "",
        DiscountPercentage: null,
        applyto: null,
        MembershipPricing: "",
        StartTime: "",
        EndTime: "",
      },
      e6: [""],
      valuearry: [
        // "Public Price",
        "Starter",
        "Access",
        "Standard",
        "Practitioner",
        "Instructor",
        "Life Science",
        "Deceased",
        "InActive",
        "Trainee Instructor",
        "Senior Instructor"
      ],
      div: 0,
      divs: [
        // {
        //   Id: 0,
        //   StoreId: 0,
        //   MemberId: 0,
        //   Price: 0,
        // },
      ],
      date: false,
      // date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menumodal: false,
      memberError: "",
      menu: false,
      modal: false,
      menuenddate: false,
      selected: "English",
      memberArray: [
        "Starter",
        "Access",
        "Life Science",
        "Standard",
        "Practitioner",
        "Instructor",
      ],
    };
  },
  computed: {
    ...mapGetters(["getMembership"]),
  },
  mounted() {
    this.$store.dispatch("getMembership");
    if (this.pricingcomp) {
      this.formData.price = this.pricingcomp.PublicPrice;
      if (
        this.pricingcomp.MemberPricing != undefined &&
        this.pricingcomp.MemberPricing.length > 0
      ) {
        this.divs = this.pricingcomp.MemberPricing;
        this.$emit("SetMemberPricing", this.divs);
      }
      this.formData.DiscountPercentage = this.pricingcomp.DiscountPercentage;
      this.showform = this.pricingcomp.Discounted;
      this.formData.applyto = this.pricingcomp.DiscountMembers.split(",");
      if (this.pricingcomp.StartTime !== null) {
        this.formData.StartTime =
          this.pricingcomp.StartTime.split("T")[0].split("-")[0] != "0001"
            ? this.pricingcomp.StartTime.split("T")[0]
            : null;
      }
      if (this.pricingcomp.EndTime !== null) {
        this.formData.EndTime =
          this.pricingcomp.EndTime.split("T")[0].split("-")[0] != "0001"
            ? this.pricingcomp.EndTime.split("T")[0]
            : null;
      }
      this.taxable = this.pricingcomp.Istaxable;
    }
  },
  validations: {
    formData: {
      price: { required },
      DiscountPercentage: { required },
      StartTime:{required},
      EndTime:{required},
    },
  },
  methods: {
    check() {
      this.$v.$touch();
      if (this.divs.length === 1 && this.divs[0].MemberId === 0) {
        this.memberError = "Atleast on member price is required";
      }
    },
    SetStartDate() {
      this.$refs.menumodal.save(this.formData.StartTime);
      this.$emit("SetStartDate", this.formData.StartTime);
    },
    SetEndDate() {
      this.$refs.modal.save(this.formData.EndTime);
      this.$emit("SetEndDate", this.formData.EndTime);
    },
    SetPrice(e) {
      this.$emit("SetPrice", e);
    },
    SetDiscount(e) {
      this.$emit("SetDiscount", e);
    },
    SetPercentage(e) {
      this.$emit("SetPercentage", e);
    },
    SetApplyTo(e) {
      this.$emit("SetApplyTo", e);
    },
    SetTaxable(e) {
      this.$emit("SetTaxable", e);
    },
    addRow() {
      this.divs.push({
        Id: 0,
        StoreId: 0,
        MemberId: 0,
        Price: 0,
      });
      this.$emit("SetMemberPricing", this.divs);
    },
    deleteRow(index) {
      this.divs.splice(index, 1);
      this.$emit("SetMemberPricing", this.divs);
    },
    updateMemberPricing() {
      this.$emit("SetMemberPricing", this.divs);
    },
  },
};
</script>

<style scoped>
.red--text {
  color: red;
  font-size: 14px;
}
.text-heading {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 31px;

  /* Color/General/Black High Emphasis */

  color: #222222;
}
</style>
